import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "name", "checked", "children", "onChange", "disabled", "theme", "onRight"];
import React from 'react';
import PropTypes from 'prop-types';
import withTheme from '../theme/withTheme';
import { Wrapper, Text, Label, ToggleSwitch, Input } from './styles';
var Switch = function Switch(_ref) {
  var className = _ref.className,
    name = _ref.name,
    checked = _ref.checked,
    children = _ref.children,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    theme = _ref.theme,
    onRight = _ref.onRight,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    position: onRight
  }, /*#__PURE__*/React.createElement(Input, _extends({
    name: name,
    type: "checkbox",
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    theme: theme
  }, rest)), /*#__PURE__*/React.createElement(ToggleSwitch, {
    disabled: disabled,
    theme: theme
  })), children && /*#__PURE__*/React.createElement(Text, {
    theme: theme
  }, children));
};
Switch.defaultProps = {
  checked: false,
  onChange: function onChange() {}
};
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func
} : void 0;
export default withTheme(Switch);